import React, { createContext, useCallback, useContext, useReducer } from 'react';

const UPDATE_NOTIFICATIONS_DATA = 'UPDATE';
const ADD_TO_NOTIFICATIONS = 'ADD';
const ADD_TO_NOTIFICATIONS_END = 'ADD_END';
const UPDATE_NOTIFICATION_CLICK_STATUS = 'UPDATE_CLICKED';
const UPDATE_META = 'UPDATE_META';
const NOTIFICATIONS_COUNT = 'NOTIFICATIONS_COUNT';
const LATEST_NOTIFICATIONS_ID = 'LATEST_NOTIFICATIONS_ID';

const defaultNotificationsState = {
  notificationsCount: 0,
  latestNotificationId: null,
  notificationsData: [],
  notificationsMeta: {
    hasMore: true,
    loading: true,
    error: null,
  },
};

const notificationsReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_NOTIFICATIONS_DATA: {
      return { ...state, notificationsData: payload.data };
    }
    case ADD_TO_NOTIFICATIONS: {
      // Adding new notifications to the front
      const newNotificationsData = [...payload.data, ...state.notificationsData];
      return { ...state, notificationsData: newNotificationsData };
    }
    case ADD_TO_NOTIFICATIONS_END: {
      // Adding new notifications to the end
      const newNotificationsData = [...state.notificationsData, ...payload.data];
      return { ...state, notificationsData: newNotificationsData };
    }
    case UPDATE_NOTIFICATION_CLICK_STATUS: {
      const newState = [...state.notificationsData];
      const notification = newState.find((n) => n.id === payload.id);
      notification.isClicked = true;
      return { ...state, notificationsData: newState };
    }
    case UPDATE_META:
      return { ...state, notificationsMeta: { ...state.notificationsMeta, ...payload.data } };
    case NOTIFICATIONS_COUNT:
      return { ...state, notificationsCount: payload.count };
    case LATEST_NOTIFICATIONS_ID:
      return { ...state, latestNotificationId: payload.id };

    default:
      return state;
  }
};

const NotificationsContext = createContext(defaultNotificationsState);

export const NotificationsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(notificationsReducer, defaultNotificationsState);

  const addToNotifications = useCallback((data) => {
    dispatch({
      type: ADD_TO_NOTIFICATIONS,
      payload: { data },
    });
  }, []);

  const updateNotifications = useCallback((data) => {
    dispatch({
      type: UPDATE_NOTIFICATIONS_DATA,
      payload: { data },
    });
  }, []);

  const addToEndOfNotifications = useCallback((data) => {
    dispatch({
      type: ADD_TO_NOTIFICATIONS_END,
      payload: { data },
    });
  }, []);

  const updateNotificationClickedStatus = useCallback((id) => {
    dispatch({
      type: UPDATE_NOTIFICATION_CLICK_STATUS,
      payload: { id },
    });
  }, []);

  const updateNotificationsMeta = useCallback((data) => {
    dispatch({
      type: UPDATE_META,
      payload: { data },
    });
  }, []);

  const setNotificationsCount = useCallback((count) => {
    dispatch({
      type: NOTIFICATIONS_COUNT,
      payload: { count },
    });
  }, []);

  const setLatestNotificationsId = useCallback((id) => {
    dispatch({
      type: LATEST_NOTIFICATIONS_ID,
      payload: { id },
    });
  }, []);

  return (
    <NotificationsContext.Provider
      value={{
        state,
        addToNotifications,
        updateNotifications,
        addToEndOfNotifications,
        updateNotificationClickedStatus,
        updateNotificationsMeta,
        setNotificationsCount,
        setLatestNotificationsId,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationsContext);
